import { Component } from "@angular/core";

@Component({
	selector: "sdi-mission-statement",
	templateUrl: "./mission-statement.component.html",
	styleUrls: ["./mission-statement.component.scss"]
})
export class MissionStatementComponent {}
